/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import App from './App.vue';
import $ from 'jquery';

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);

// Theme Configurations
import '../themeConfig.js';

// Globally Registered Components
import './globalComponents.js';

// Styles: SCSS
import './assets/scss/main.scss?dsad';

// Tailwind
import '@/assets/css/main.css';

// Vue Router
import router from './router';

// i18n
import i18n from './i18n/i18n';

// Vuex Store
import store from './store/store';
import DatePicker from 'vuejs-datepicker';
Vue.component('datepicker', DatePicker);

Vue.directive('only-numbers', {
    inserted(el) {
        let input = el;
        if (el.classList.contains('vs-input')) {
            input = el.querySelector('input');
        }
        input.addEventListener('input', () => {
            if (/[^\d]+/.test(input.value)) {
                let start = input.selectionStart;
                input.value = input.value.replace(/[^\d]/g, '');
                input.setSelectionRange(start - 1, start - 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });
    },
});

// Used in Forms v2
Vue.directive('only-numbers-v2', {
    bind(el, binding, vnode, oldVnode) {
        if (binding.value) {
            el.addEventListener('input', () => {
                if (/[^\d]+/.test(el.value)) {
                    let start = el.selectionStart;
                    el.value = el.value.replace(/[^\d]/g, '');
                    el.setSelectionRange(start - 1, start - 1);
                    el.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        }
    },
});

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
    useConstraintAttrs: false, // https://github.com/logaretm/vee-validate/issues/2043
});

import BodyLock from 'v-body-scroll-lock';
Vue.use(BodyLock);

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(PerfectScrollbar);

// Vuesax Admin Filters
import './filters/filters';

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

// Feather font icon
require('./assets/css/iconfont.css');

const VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo);
Vue.use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});

import Resources from './helpers/methods/resources';
import Helpers from './helpers/methods/helpers';
import { locale } from './helpers/methods/locale';
import { Validator } from 'vee-validate';

Vue.mixin({
    methods: {
        ...Resources,
        ...Helpers,
        ...locale,
    },
});

Vue.config.productionTip = false;

const vm = new Vue({
    router,
    store,
    i18n,
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler() {
                import(`vee-validate/dist/locale/${this.$i18n.locale}`).then((locale) => {
                    Validator.localize(this.$i18n.locale, locale);
                });

                if ($.fn.select2.locales[this.$i18n.locale]) {
                    $.extend($.fn.select2.defaults, $.fn.select2.locales[this.$i18n.locale]);
                } else {
                    import(`select2/select2_locale_${this.$i18n.locale}.js`);
                }
            },
        },
    },
    render: (h) => h(App),
}).$mount('#app');

// For testing from console
window.__app = vm;
